<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.back();"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
        :model="info"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
    >
      <el-form-item label="使用范围">
        <label slot="label"><span style="color:red">*</span>使用范围</label>
        <el-select
            class="search-el"
            size="medium"
            v-model="info.type"
            @change="typeChange"
            placeholder="请选择分类"
            clearable
            filterable
            :disabled="info.id > 0 || !this.info.edit_status"
        >
          <el-option label="请选择分类" value="0"></el-option>
          <el-option label="线上课程通用券" value="22"></el-option>
          <el-option label="365会员" value="1"></el-option>
          <el-option label="普通课程" value="2"></el-option>
          <el-option label="线下课" value="3"></el-option>
          <el-option label="新直播课" value="5"></el-option>
          <el-option label="生活馆" value="7"></el-option>
          <el-option label="有声书" value="10"></el-option>
          <el-option label="兑换券" value="21"></el-option>
          <el-option label="专题课" value="12"></el-option>
          <el-option label="个案咨询" value="16"></el-option>
          <el-option label="体验营" value="23"></el-option>
          <el-option label="心理咨询" value="17"></el-option>
          <el-option label="树洞咨询" value="18"></el-option>
        </el-select>
        <div>
          使用范围一经选择，将不可修改。 请选择具体类目，比如普通课程或生活馆
        </div>
      </el-form-item>

      <el-form-item label="参与商品" v-if="is_show_type == 1 && info.type != '0'">
        <label slot="label"><span style="color:red">*</span>参与商品</label>
        <el-radio-group v-model="info.product_involved_type" :disabled="!this.info.edit_status" @change="productChange">
          <el-radio :label="1">指定商品参与</el-radio>
          <el-radio :label="0">全部商品参与</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="参与课程" v-if="is_show_type == 2 && info.type != '0'">
        <label slot="label"><span style="color:red">*</span>参与课程</label>
        <el-radio-group v-model="info.course_involved_type" :disabled="!this.info.edit_status" @change="courseChange">
          <el-radio :label="1">指定课程参与</el-radio>
          <el-radio :label="0">全部课程参与</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="参与咨询师" v-if="info.type == 17 || info.type == 18">
        <label slot="label"><span style="color:red">*</span>参与咨询师</label>
        <el-radio-group v-model="info.course_involved_type" :disabled="!this.info.edit_status">
          <el-radio :label="1">指定咨询师参与</el-radio>
          <el-radio :label="0">全部咨询师参与</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="商品名称" v-if="is_show_product == 1">
        <label slot="label"><span style="color:red">*</span>商品名称</label>
        <el-col :span="15">
          <el-input
              v-model="info.target_title"
              placeholder="请选择商品"
              :disabled="true"
          ></el-input>
        </el-col>
        <el-button
            :disabled="!this.info.edit_status"
            type="primary"
            size="small"
            @click="
            product.chooseOrgVisible = true;
            searchDataProduct();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-form-item label="课程名称" v-if="is_show_course == 1">
        <label slot="label"><span style="color:red">*</span>课程名称</label>
        <el-col :span="15">
          <el-input
              v-model="info.target_title"
              placeholder="请选择课程"
              :disabled="true"
          ></el-input>
        </el-col>
        <el-button
            :disabled="!this.info.edit_status"
            type="primary"
            size="small"
            @click="
            course.chooseOrgVisible = true;
            searchDataCourse();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-form-item label="咨询师" v-if="(info.type == 17 || info.type == 18) && info.course_involved_type == 1">
        <label slot="label"><span style="color:red">*</span>咨询师</label>
        <el-col :span="15">
          <el-input
              v-model="info.target_title"
              placeholder="请选择咨询师"
              :disabled="true"
          ></el-input>
        </el-col>
        <el-button
            :disabled="!this.info.edit_status"
            type="primary"
            size="small"
            @click="
            counselor.chooseOrgVisible = true;
            searchDataCounselor();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-row v-if="is_show_product == 1 || is_show_course == 1">
        <el-table
            :data="productInfo.product_arr"
            border
            size="mini"
            :stripe="true"
            style="width: 60%; margin: 20px 50px"
        >
          <el-table-column
              prop="id"
              label="ID"
              align="center"
              min-width="5%"
          ></el-table-column>
          <el-table-column
              prop="status"
              label="状态"
              align="center"
              min-width="10%"
          ></el-table-column>
          <el-table-column label="图片" align="center" min-width="15%">
            <template slot-scope="{ row }">
              <img :src="row.img_url" style="width: 46px; height: 35px;" alt=""/>
            </template>
          </el-table-column>
          <el-table-column
              prop="title"
              label="名称"
              align="center"
              min-width="20%"
          ></el-table-column>
          <el-table-column
              prop="price"
              label="价格"
              align="center"
              min-width="10%"
          ></el-table-column>
        </el-table>
      </el-row>

      <el-form-item label="券类别">
        <label slot="label"><span style="color:red">*</span>券类别</label>
        <el-radio-group v-model="info.coupon_category" @change="couponCategoryChange" :disabled="is_agent_price ==1">
          <el-radio :label="0" value="normal" :disabled="!this.info.edit_status">普通满减券</el-radio>
          <el-radio v-if="1 == 0" :label="1" value="discount" :disabled="!this.info.edit_status">折扣券</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="标题" prop="name">
        <label slot="label"><span style="color:red">*</span>标题</label>
        <el-input
            v-model="info.name"
            maxlength="30"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="满多少" prop="start" v-if="is_show_coupon_category == 0">
        <label slot="label"><span style="color:red">*</span>满多少</label>
        <el-input
            :disabled="!this.info.edit_status"
            v-model="info.start"
            @input="inputStartChange"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="减多少" prop="reduce" v-if="is_show_coupon_category == 0">
        <label slot="label"><span style="color:red">*</span>减多少</label>
        <el-input
            :disabled="!this.info.edit_status"
            v-model="info.reduce"
            @input="inputReduceChange"
            show-word-limit
            style="width:33%"
        ></el-input>
        <span v-if="info_type == 23 && info.course_involved_type == 1 && this.productInfo.product_arr.length != 0">可输入最大值为: {{ info.reduce }}</span>
      </el-form-item>

      <el-form-item label="折扣价" prop="reduce" v-if="is_show_coupon_category == 1">
        <label slot="label"><span style="color:red">*</span>折扣价</label>
        <el-input
            :disabled="!this.info.edit_status"
            v-model="info.reduce"
            @input="inputReduceChange"
            show-word-limit
            style="width:33%"
        ></el-input>
        <div>
          请填入 整数 的折扣数额，折扣价如95折，添写数字95；如8折，填写数字80；折扣数额范围： 10~99
        </div>
      </el-form-item>

      <el-form-item label="发放总量" prop="stock">
        <label slot="label"><span style="color:red">*</span>发放总量</label>
        <el-input
            v-model="info.stock"
            @input="inputStockChange"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="开始时间">
        <label slot="label"><span style="color:red">*</span>用券时间</label>
        <el-radio-group v-model="info.assert_type" @change="assertTypeChange" :disabled="!this.info.edit_status">
        <el-radio :label="0" value="0">默认</el-radio>
        <el-date-picker
            v-model="info.begin_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            default-time="00:00:00"
            :disabled="info.assert_type==1 || !this.info.edit_status"
            style="width: 40%"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
            v-model="info.expire_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择到期时间"
            :disabled="info.assert_type==1 || !this.info.edit_status"
            default-time="23:59:59"
            @change="handleDateChange">
            style="width: 27%"
        >
        </el-date-picker>

          <br><br>
          <el-radio :label="1" value="1">领券后立即生效，有效期天数为</el-radio>
          <el-input :disabled="info.assert_type==0 || !this.info.edit_status"  :min="1" v-model="info.assert_days" @input="inputAssertDaysChange" style="width:35%;margin-top: 10px;margin-left: 11px" placeholder="有效期xx天"></el-input>

        </el-radio-group><br>
        <span style="color: red">例: 有效期填写的4天，则客户在 1月1日9:00 领券，该券的可用时间为 1月1日00:00:00 至1月4日23:59:59 (按自然天计算)</span>
      </el-form-item>

<!--      <el-form-item v-if="info.assert_type == 1">
        <label slot="label"><span style="color:red">*</span>生效天数</label>
        <el-input v-model="info.assert_days" @input="inputAssertDaysChange" style="width:33%" placeholder="有效期xx天"></el-input>
      </el-form-item>-->

      <el-form-item label="领取方式">
        <label slot="label"><span style="color:red">*</span>领取方式</label>
        <el-radio-group v-model="info.receive_type" @change="receiveTypeChange" :disabled="!this.info.edit_status">
          <el-radio :label="0" value="0">默认</el-radio>
          <el-radio  :label="1" style="width:11%;margin-left: 6px;" value="1">每人限领次数</el-radio> <el-input  :min="1" size="small" :disabled="info.receive_type==0 || info.receive_type==2 || !this.info.edit_status" v-model="info.receive_nums" @input="inputReceiveNumsChange" style="width:10%;"></el-input>
          <el-radio  :label="2" style="width:11%;margin-left: 6px;" value="2">每天限领次数</el-radio> <el-input  :min="1" size="small" :disabled="info.receive_type==0 || info.receive_type==1 || !this.info.edit_status" v-model="info.receive_nums_2" @input="inputReceiveNums2Change" style="width:9%;"></el-input>
        </el-radio-group>
      </el-form-item>

<!--      <el-form-item v-if="info.receive_type == 1 || info.receive_type == 2">
        <label slot="label"><span style="color:red">*</span>限领次数</label>
        <el-input v-model="info.receive_nums" @input="inputReceiveNumsChange" style="width:33%" placeholder="请输入限领次数"></el-input>
      </el-form-item>-->

      <el-form-item label="客服姓名" prop="counselor_name">
        <el-input
            v-model="info.counselor_name"
            maxlength="30"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="客服微信号" prop="counselor_wechat">
        <el-input
            v-model="info.counselor_wechat"
            maxlength="30"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>

      <el-form-item label="客服二维码">
        <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="imageUploadOSSRequest3"
            :before-upload="beforeImageUpload"
            accept="image/*"
        >
          <img v-if="info.counselor_wechat_img" :src="info.counselor_wechat_img" class="avatar2"/>
          <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-checkbox :disabled="!this.info.edit_status" style="margin-right: 5px" v-model="info.overdue_remind_type" @change="overDueRemindTypeChange"></el-checkbox>
        <label slot="label">过期提醒</label>
        <span style="margin: 5px">优惠券过期前</span>
        <el-input v-model="info.overdue_remind_days" :min="1" :disabled="!info.overdue_remind_type || !this.info.edit_status" @input="inputOverdueRemindDaysChange" style="width:4%" ></el-input>
<!--        <label slot="label">短信模版ID</label>-->
        <span style="margin: 5px">天，发送短信提醒</span>
        <span style="margin-left: 10px;margin-right: 5px">短信模板ID</span>
        <el-input v-model="info.message_template_id" :disabled="!info.overdue_remind_type || !this.info.edit_status" @input="inputMessageTemplateChange" style="width:8%" ></el-input>
        <br><span style="color: red;margin-left: 10px">提示: 设置后将在提醒天12点30触发提醒短信</span>
      </el-form-item>
<!--      <el-form-item>
        <label slot="label">短信模版ID</label>
        <el-input v-model="info.message_template_id" style="width:33%" placeholder="请输入短信模版ID"></el-input>
      </el-form-item>-->

      <el-form-item label="剩余数量显示">
        <el-radio-group v-model="info.show_nums" :disabled="!this.info.edit_status">
          <el-radio :label="1">正常显示</el-radio>
          <el-radio :label="0">不显示</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="申请理由" prop="reason">
        <el-input
            :disabled="!this.info.edit_status"
            type="textarea"
            maxlength="50"
            :rows="5"
            show-word-limit
            style="width: 35%;"
            v-model="info.reason">
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button
            size="small"
            type="primary"
            @click="createUpdate()"
            :loading="updateLoading"
        >确 定
        </el-button
        >
      </el-form-item>
    </el-form>

    <!--商品-->
    <el-dialog
        title="选择商品"
        :visible.sync="product.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnCloseProduct"
        width="75%"
    >
      <el-form :inline="true" :model="product.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="product.query.search"
              placeholder="输入标题或ID"
              clearable
              @blur="searchDataProduct()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchDataProduct();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="product.result.data"
          highlight-current-row
          v-loading="product.listLoading1"
          style=""
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="status"
            label="状态"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="searchDataProduct"
          :current-page.sync="product.query.page"
          :page-size="product.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="product.result.total"
      >
      </el-pagination>
    </el-dialog>
    <!--课程-->
    <el-dialog
        title="选择课程"
        :visible.sync="course.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnCloseCourse"
        width="75%"
    >
      <el-form :inline="true" :model="course.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="course.query.search"
              placeholder="输入标题或ID"
              clearable
              @blur="searchDataCourse()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchDataCourse();
            "
          >
            查询
          </el-button>
          
          <span style="font-size: 13px; color: #D9001B;margin-left: 10px;">
            如未查询到对应课程，请查看该课程是否允许使用优惠券
          </span>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="course.result.data"
          highlight-current-row
          v-loading="course.listLoading1"
          style=""
      >
        <el-table-column label="ID" align="center">
          <template slot-scope="{ row }">
            {{ row.id }}{{ row.extra_type == 1 ? ('【排期课】') : '' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="status"
            label="状态"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectCourse(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="searchDataCourse"
          :current-page.sync="course.query.page"
          :page-size="course.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="course.result.total"
      >
      </el-pagination>
    </el-dialog>

    <!--咨询师-->
    <el-dialog
        title="选择咨询师"
        :visible.sync="counselor.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnCloseCounselor"
        width="75%"
    >
      <el-form :inline="true" :model="counselor.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="counselor.query.search"
              placeholder="请输入标题或ID"
              clearable
              @blur="searchDataCounselor()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchDataCounselor();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="counselor.result.data"
          highlight-current-row
          v-loading="counselor.listLoading1"
          style=""
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectCounselor(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="searchDataCounselor"
          :current-page.sync="counselor.query.page"
          :page-size="counselor.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="counselor.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  imageUploadOSSRequest,
  beforeImageUpload,
  getAliyunOssToken,
} from "@/api/common";

import {
  couponDataSaveNew,
  couponInfoNew,
  couponCourseScreen,
  couponProductScreen,
  screenProductList
} from "@/api/coupon";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      editor: null,
      is_show_type: 0,
      is_show_product: 0,
      is_show_course: 0,
      is_show_coupon_category: 0,
      info_type: 0,
      tyy_max: 0,
      copy_type: 1,
      info: {
        id: 0,
        type: "0",
        coupon_category: 0,
        product_involved_type: 1,
        course_involved_type: 1,
        name: "",
        start: "",
        reduce: "",
        stock: "",
        begin_at: "",
        expire_at: "",
        counselor_name: "",
        counselor_wechat: "",
        counselor_wechat_img: "",
        show_nums: 1,
        target_title: "",
        target_id: 0,
        admin_id: 0,
        initial_target_id : 0,
        assert_type: 0, //生效方式
        assert_days: "", //生效天数
        receive_type: 0, //领取方式  0、默认（原有不限制）1、按人 2、按天'
        receive_nums: '',//领取次数
        receive_nums_2: '',//领取次数
        overdue_remind_days: '',//过期提醒天数
        overdue_remind_type: false,//过期提醒天数
        message_template_id: '',//短信模版ID
        reason: '',//申请理由
        edit_status: true//是否可以编辑 true 可以 false 不可以
      },

      productInfo: {
        product_arr: []
      },
      is_agent_price: 0,
      agent_price_diff: 0,

      product: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      course: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 0,
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      counselor: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 17,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.info.id = this.$route.query.id;
    this.info.admin_id = this.$route.query.admin_id;
    this.copy_type = this.$route.query.copy_type;
    if (this.info.id > 0) {
      this.getInfo(this.copy_type);
    }else{//新增
      this.info.edit_status = true;//新增，默认为可以编辑
    }
  },
  mounted() {
  },
  methods: {
    inputStartChange(val) {
      this.info.start = this.info.start.replace(/[^0-9.]/g, '')
    },
    inputReduceChange(val) {
      this.info.reduce = this.info.reduce.replace(/[^0-9.]/g, '')
      console.log(this.productInfo.product_arr)
      if (this.info_type == 23 && (this.productInfo.product_arr.length != 0)) {
        var max = this.tyy_max;
        console.log(max, val)
        if (val > max) {
          this.info.reduce = max;
        }
      }
    },
    inputStockChange(val) {
      this.info.stock = this.info.stock.replace(/[^0-9.]/g, '')
    },
    inputAssertDaysChange(val) {
      this.info.assert_days = this.info.assert_days.replace(/[^0-9]/g, '');
    },
    inputReceiveNumsChange(val) {
      this.info.receive_nums = this.info.receive_nums.replace(/[^0-9]/g, '')
    },
    inputReceiveNums2Change(val) {
      this.info.receive_nums_2 = this.info.receive_nums_2.replace(/[^0-9]/g, '')
    },
    inputOverdueRemindDaysChange(val) {
      this.info.overdue_remind_days = this.info.overdue_remind_days.replace(/[^0-9]/g, '')
    },
    inputMessageTemplateChange(val) {
      this.info.message_template_id = this.info.message_template_id.replace(/[^0-9]/g, '')
    },
    assertTypeChange(){
      if(this.info.assert_type == 1 && this.info.assert_days == ''){
        this.info.assert_days = 1;
      }
    },
    receiveTypeChange(){
      if(this.info.receive_type == 1 && this.info.receive_nums == ''){
        this.info.receive_nums = 1
        this.info.receive_nums_2 = ''
      }else if(this.info.receive_type == 2 && this.info.receive_nums_2 == ''){
        this.info.receive_nums = ''
        this.info.receive_nums_2 = 1
      }else{
        this.info.receive_nums = ''
        this.info.receive_nums_2 = ''
      }
    },
    overDueRemindTypeChange(){
      if(this.info.overdue_remind_type == true && this.info.overdue_remind_days == ''){
        this.info.overdue_remind_days = 1;
      }
    },

    // 咨询师 弹窗关闭
    addEditFormOnCloseCounselor() {
      this.counselor.query.page = 1;
      this.counselor.query.search = "";
      this.counselor.result = {
        total: 0,
        data: [],
      };
      this.counselor.chooseOrgVisible = false;
    },
    // 查询方法
    searchDataCounselor() {
      this.counselor.listLoading1 = true;
      this.counselor.query.target_type = this.info.type;
      screenProductList(this.counselor.query).then((response) => {
        this.counselor.result.data = response.data.list;
        this.counselor.result.total = response.data.total;
        this.counselor.listLoading1 = false;
      });
    },
    selectCounselor(row) {
      this.addEditFormOnCloseCounselor();
      this.info.target_id = row.id;
      this.info.target_title = row.title;      
      this.counselor.chooseOrgVisible = false;
    },

    // 弹窗关闭
    addEditFormOnCloseProduct() {
      this.product.query.page = 1;
      this.product.query.search = "";
      this.product.result = {
        total: 0,
        data: [],
      };
      this.product.chooseOrgVisible = false;
    },
    // 查询方法
    searchDataProduct() {
      this.product.listLoading1 = true;
      couponProductScreen(this.product.query).then((response) => {
        this.product.result.data = response.data.list;
        this.product.result.total = response.data.total;
        this.product.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.initialData()
      console.log(row.product_arr)
      this.productInfo.product_arr = row.product_arr;
      this.info.target_id = row.id;
      this.info.target_title = row.title;
      this.product.chooseOrgVisible = false;
    },

    // 弹窗关闭
    addEditFormOnCloseCourse() {
      this.course.query.page = 1;
      this.course.query.type = 0;
      this.course.query.search = "";

      this.course.result = {
        total: 0,
        data: [],
      };
      this.course.chooseOrgVisible = false;
    },
    // 查询方法
    searchDataCourse() {
      this.course.query.type = this.info_type
      this.course.listLoading1 = true;
      couponCourseScreen(this.course.query).then((response) => {
        this.course.result.data = response.data.list;
        this.course.result.total = response.data.total;
        this.course.listLoading1 = false;
      });
    },

    selectCourse(row) {
      this.initialData()
      console.log(row.product_arr)
      this.productInfo.product_arr = row.product_arr;
      this.info.target_id = row.id;
      this.info.target_title = row.title;
      this.is_agent_price = row.is_agent_price;
      this.agent_price_diff = row.agent_price_diff;
      if (this.is_agent_price == 1) {
        this.info.start = row.price;
        this.info.stock = 1;
        this.info.coupon_category = 0;
        this.is_show_coupon_category = 0;
      }
      if (this.is_agent_price == 1) {
        this.info.reduce = row.agent_price_diff;
      }
      if (this.info_type == 23) {
        this.info.start = row.tyy_start_price;
        this.info.reduce = row.tyy_reduce_price;
        this.tyy_max = row.tyy_reduce_price;
        this.info.stock = 1;
        this.info.coupon_category = 0;
        this.is_show_coupon_category = 0;
        this.is_agent_price = 1
      }
      this.course.chooseOrgVisible = false;
    },

    typeChange(val) {
      // if (val == 17) return;
      this.initialData()
      this.is_show_product = 0
      this.is_show_course = 0
      this.productInfo.product_arr = []
      this.info.target_id = 0;
      this.info.target_title = ''
      this.info_type = val
      this.is_agent_price = 0
      this.info.product_involved_type = 1
      this.info.course_involved_type = 1
      this.info.coupon_category = 0
      console.log(val)
      if (val == 7) {
        this.is_show_type = 1
        if (this.info.product_involved_type == 1) {
          this.is_show_product = 1
        }
      } else if (val == 17 || val == 18) {
        this.is_show_type = 0
      } else {
        if (val == 1 || val == 21 || val == 0) {
          this.is_show_type = 0
          this.info.product_involved_type = this.info.course_involved_type = 0;
        } else {
          this.is_show_type = 2
          if (this.info.course_involved_type == 1) {
            this.is_show_course = 1
          }
          if (val == 23) {
            this.is_agent_price = 1
          }
        }
      }
    },

    productChange(val) {
      this.initialData()
      this.productInfo.product_arr = []
      this.info.target_title = ''
      this.is_agent_price = 0;
      console.log(val)
      if (val == 1) {
        this.is_show_product = 1
        this.is_show_course = 0
      } else {
        this.is_show_product = 0
        this.is_show_course = 0
      }
    },

    courseChange(val) {
      this.initialData()
      this.productInfo.product_arr = []
      this.info.target_title = ''
      console.log(val)
      if (val == 1) {
        this.is_show_course = 1
        this.is_show_product = 0
      } else {
        this.is_show_course = 0
        this.is_show_product = 0
        this.is_agent_price = 0;
      }
    },

    couponCategoryChange(val) {
      this.initialData()
      this.info.reduce = '';
      console.log(val)
      if (val == 1) {
        this.is_show_coupon_category = 1
      } else {
        this.is_show_coupon_category = 0
      }
    },

    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    imageUploadOSSRequest3(file) {
      getAliyunOssToken({dir: ""}).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.counselor_wechat_img = fileUrl;
        });
      });
    },

    initialData() {
      if (this.copy_type == 1) {
        this.info.name = ""
        this.info.start = ""
        this.info.reduce = ""
        this.info.stock = ""
        this.info.begin_at = ""
        this.info.expire_at = ""
      }
    },

    getInfo(copy_type) {
      this.loading = true;
      couponInfoNew({
        id: this.info.id,
      }).then((response) => {
        if (copy_type == 1) {
          this.info.id = response.data.id;
          this.info.type = response.data.type_value;
          this.info.coupon_category = response.data.coupon_category;
          this.info.product_involved_type = response.data.product_involved_type;
          this.info.course_involved_type = response.data.course_involved_type;
          this.info.name = response.data.name;
          this.info.start = response.data.start;
          this.info.reduce = response.data.reduce;
          this.info.stock = response.data.stock;
          this.info.begin_at = response.data.begin_at;
          this.info.expire_at = response.data.expire_at;
          this.info.counselor_name = response.data.counselor_name;
          this.info.counselor_wechat = response.data.counselor_wechat;
          this.info.counselor_wechat_img = response.data.counselor_wechat_img;
          this.info.show_nums = response.data.show_nums;
          this.info.target_title = response.data.target_title;
          this.info.target_id = response.data.target_id
          this.info.initial_target_id = response.data.target_id
          this.info.assert_type = response.data.assert_type
          this.info.assert_days = response.data.assert_days
          this.info.receive_type = response.data.receive_type
          if(response.data.receive_type == 1){
            this.info.receive_nums = response.data.receive_nums
            this.info.receive_nums_2 = ''
          }else if(response.data.receive_type == 2){
            this.info.receive_nums_2 = response.data.receive_nums
            this.info.receive_nums = ""
          }else{
            this.info.receive_nums = '';
            this.info.receive_nums_2 = '';
          }
          if(response.data.assert_type == 0){
            this.info.assert_days = ''
          }else{
            this.info.begin_at = ''
            this.info.expire_at = ''
          }

          this.info.overdue_remind_days = response.data.overdue_remind_days
          if(response.data.overdue_remind_days > 0){
            this.info.overdue_remind_type = true;
          }else{
            this.info.overdue_remind_type = false;
            this.info.overdue_remind_days = '';
          }
          this.info.message_template_id = response.data.message_template_id
          this.info.reason = response.data.reason
          this.productInfo.product_arr = response.data.product_arr;
          this.info_type = response.data.type_value
          this.is_agent_price = response.data.is_agent_price
          this.agent_price_diff = response.data.agent_price_diff
          this.info.edit_status = response.data.edit_status
          this.tyy_max = response.data.reduce;
        } else {
          this.info.id = 0;
          this.info.type = response.data.type_value;
          this.info.name = response.data.name;
          this.info.start = response.data.start;
          this.info.reduce = response.data.reduce;
          this.info.stock = response.data.stock;
          this.info.counselor_name = response.data.counselor_name;
          this.info.counselor_wechat = response.data.counselor_wechat;
          this.info.counselor_wechat_img = response.data.counselor_wechat_img;
          this.info.show_nums = response.data.show_nums;
          this.info_type = response.data.type_value
          //复制增加生效时间和生效方式
          this.info.begin_at = response.data.begin_at
          this.info.expire_at = response.data.expire_at
          this.info.assert_type = response.data.assert_type
          this.info.assert_days = response.data.assert_days
          this.info.receive_type = response.data.receive_type
          this.info.receive_nums = response.data.receive_nums
          if(response.data.receive_type == 1){
            this.info.receive_nums = response.data.receive_nums
            this.info.receive_nums_2 = ''
          }else if(response.data.receive_type == 2){
            this.info.receive_nums_2 = response.data.receive_nums
            this.info.receive_nums = ""
          }else{
            this.info.receive_nums = '';
            this.info.receive_nums_2 = '';
          }
          if(response.data.assert_type == 0){
            this.info.assert_days = ''
          }else{
            this.info.begin_at = ''
            this.info.expire_at = ''
          }
          this.info.edit_status = true;//若为复制，择默认为可以编辑
          this.tyy_max = response.data.reduce;
        }
        console.log(response.data);
        this.loading = false;
        if (this.info.type == 7) {
          this.is_show_type = 1
          if (this.info.product_involved_type == 1) {
            this.is_show_product = 1
          }
        } else {
          if (this.info.type == 1 || this.info.type == 21 || this.info.type == 0 || this.info.type == 17) {
            this.is_show_type = 0
          } else {
            this.is_show_type = 2
            console.log(this.info.course_involved_type)
            if (this.info.course_involved_type == 1) {
              this.is_show_course = 1
            }
          }
        }
        if (this.info.coupon_category == 1) {
          this.is_show_coupon_category = 1
        } else {
          this.is_show_coupon_category = 0
        }
      });
    },
    handleDateChange(value) {
      console.log(this.info.expire_at)
      if (value && this.info.expire_at == '') {
        const date = new Date(value);
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        console.log(this.info.expire_at)
        this.info.expire_at = date;
      }
    },
    createUpdate() {
      console.log(this.info)
      if (this.info.type == '0') {
        this.$message.error('请选择分类!')
        return false
      }
      if (this.info.type == '7' && this.info.product_involved_type == 1 && this.info.target_title == '') {
        this.$message.error('请选择商品!')
        return false
      }
      if (this.info.type != '7' && this.info.type != '1' && this.info.type != '21' && this.info.type != 17 && this.info.course_involved_type == 1 && this.info.target_title == '') {
        this.$message.error('请选择课程!')
        return false
      }
      if (this.info.type == 17 || this.info.type == 18) {
        if (this.info.course_involved_type == 1) {
          if (this.info.target_id <= 0) {
            this.$message.error('请选择咨询师!')
            return false
          }          
        }
      }
      if (this.info.name == '') {
        this.$message.error('标题不能为空!')
        return false
      }
      if (this.is_show_coupon_category == 0) {
        if (this.info.start === '') {
          this.$message.error('满多少不能为空!')
          return false
        }
      } else {
        this.info.start = 0;
      }
      if ((this.info.reduce === '' || this.info.reduce <= 0) && (this.is_show_coupon_category == 0)) {
        this.$message.error('减多少不能为空！不能小于0')
        return false
      }
      if ((this.info.reduce === '' || this.info.reduce <= 0 || this.info.reduce >= 100) && (this.is_show_coupon_category == 1)) {
        this.$message.error('折扣价无效！有效值： 1~99')
        return false
      }
      if (this.info.stock == '' || this.info.stock <= 0) {
        this.$message.error('发放总量不能为空!')
        return false
      }
      if ((this.info.begin_at == '' || this.info.begin_at == null) && this.info.assert_type == 0) {
        this.$message.error('开始时间不能为空!')
        return false
      }
      if ((this.info.expire_at == '' || this.info.expire_at == null) && this.info.assert_type == 0) {
        this.$message.error('到期时间不能为空!')
        return false
      }
      if ((this.info.assert_days === '' || this.info.assert_days <= 0) && (this.info.assert_type == 1)) {
        this.$message.error('生效天数不能为空！不能小于0')
        return false
      }
      if ((this.info.receive_nums === '' || this.info.receive_nums <= 0) && (this.info.receive_type == 1)) {
        this.$message.error('限领次数不能为空！不能小于0')
        return false
      }
      if ((this.info.receive_nums_2 === '' || this.info.receive_nums_2 <= 0) && (this.info.receive_type == 2)) {
        this.$message.error('限领次数不能为空！不能小于0')
        return false
      }
      if (this.info.overdue_remind_type) {
        if (this.info.overdue_remind_days === '') {
          this.$message.error('请设置过期提醒的天数！')
          return false
        }
        if (this.info.overdue_remind_days <= 0) {
          this.$message.error('过期提醒天数不能小于1！')
          return false
        }
        if (this.info.message_template_id === '' || this.info.message_template_id <= 0) {
          this.$message.error('请设置过期提醒的短信模版ID！')
          return false
        }
      }

      this.updateLoading = true;

      //处理领取次数字段
      if(this.info.receive_type == 0){
        this.info.receive_nums = 0;
      }else if(this.info.receive_type == 2){
        this.info.receive_nums = this.info.receive_nums_2;
      }

      //处理用券时间方式字段
      if(this.info.assert_type == 0){
        this.info.assert_days = 0;
      }

      if (this.info.type == '23') {
        couponDataSaveNew(this.info)
            .then((response) => {
              this.updateLoading = false;
              if (response.code == 1) {
                this.$message.success(response.message);
                this.$router.push({
                  path: "/coupon/listNew",
                });
              }
            })
            .catch((err) => {
              this.updateLoading = false;
            });
      } else {
        if ((this.is_agent_price == 1) && (this.info.reduce == this.agent_price_diff)) {
          couponDataSaveNew(this.info)
              .then((response) => {
                this.updateLoading = false;
                if (response.code == 1) {
                  this.$message.success(response.message);
                  this.$router.push({
                    path: "/coupon/listNew",
                  });
                }
              })
              .catch((err) => {
                this.updateLoading = false;
              });
        } else {
          if(this.info.reason == ''){
            this.updateLoading = false;
            this.$message.error('请填写申请理由')
            return false;
          }
          this.$confirm("申请超过限制，需进行审批", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            couponDataSaveNew(this.info)
                .then((response) => {
                  this.updateLoading = false;
                  if (response.code == 1) {
                    this.$message.success(response.message);
                    this.$router.push({
                      path: "/coupon/listNew",
                    });
                  }
                })
                .catch((err) => {
                  this.updateLoading = false;
                });
          }).catch(() => {
            this.updateLoading = false;
          });
        }
      }
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar2 {
  width: 100px;
  height: 100px;
  display: block;
}
</style>